import {defaultUser} from "./constant";
import {User} from "../Models/User";

export const logout = ( setCurrentUser: Function) => {
    console.log("*** in logout ***")
    localStorage.removeItem('currentUser')
    setCurrentUser(new User(defaultUser))
}

/**
 * Formate un montant avec séparateurs de milliers
 * @param amount - Le montant à formater
 * @param currency - Le symbole de devise (défaut: €)
 * @returns Le montant formaté (ex: "1 234,56 €")
 */
export const formatAmount = (amount: number, currency: string = '€'): string => {
    return `${amount.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
}

/**
 * Formate un nombre avec séparateurs de milliers (sans devise)
 * @param value - Le nombre à formater
 * @returns Le nombre formaté (ex: "1 234,56")
 */
export const formatNumber = (value: number, decimals: number = 2): string => {
    return value.toLocaleString('fr-FR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}


